/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { createContext, useContext } from 'react';

export interface AgentPanelContextValue {
  closeAgentPanel: () => void;
  enterAgentFullScreen: () => void;
  exitAgentFullScreen: () => void;
  isAgentFullScreen: boolean;
  isAgentPanelOpen: boolean;
  openAgentPanel: (conversationId?: string) => void;
  /**
   * Opens the panel on a fresh conversation, optionally prefilling the chat
   * input (never auto-sent). Use this for entry points that should always start
   * a new thread rather than resume the last one.
   */
  openNewAgentConversation: (draftText?: string) => void;
  toggleAgentPanel: () => void;
}

export const AgentPanelContext = createContext<AgentPanelContextValue | undefined>(undefined);

export const useAgentPanel = () => {
  const context = useContext(AgentPanelContext);
  if (!context) {
    throw new Error('useAgentPanel must be used within AgentPanelProvider');
  }
  return context;
};

export const useOptionalAgentPanel = () => useContext(AgentPanelContext);
